import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sweepstakes-mail-code.magic.css.js';
import script from './sweepstakes-mail-code.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sweepstakes-mail-code",attrs:{"part":"sweepstakes-mail-code"}},[_c('magic-ui-text',{staticClass:"sweepstakes-mail-code__header",attrs:{"part":"sweepstakes-mail-code__header","content":_vm.$t('sweepstakes.get-mail-in-code.header')}}),_vm._v(" "),_c('div',{staticClass:"sweepstakes-mail-code__copy",attrs:{"part":"sweepstakes-mail-code__copy"}},[_c('magic-ui-input',{staticClass:"sweepstakes-mail-code__input",attrs:{"part":"sweepstakes-mail-code__input","value":_vm.mailCode,"icon":"","ellipsis":"","readonly":""}}),_vm._v(" "),_c('magic-ui-icon',{staticClass:"sweepstakes-mail-code__icon",attrs:{"name":"copy","part":"sweepstakes-mail-code__icon"},on:{"click":_vm.onCopy}})],1),_vm._v(" "),_c('magic-ui-button',{staticClass:"sweepstakes-mail-code__button",attrs:{"part":"sweepstakes-mail-code__button","wide":"","large":"","variant":"primary","loading":_vm.codeLoading},domProps:{"innerHTML":_vm._s(_vm.$t('sweepstakes.get-mail-in-code.button'))},on:{"click":_vm.getMailInCode}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-87420b92_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-87420b92";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
